import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import SuspenseWrapper from "../SuspenseWrapper";

const NotFound = lazy(() => import("../../pages/NotFound"));

export const fallbackRoutes: RouteObject[] = [
  {
    path: "*",
    element: (
      <SuspenseWrapper>
        <NotFound />
      </SuspenseWrapper>
    ),
  },
];
